function Loading() {
    return (
        <div style={{textAlign: "center", fontFamily: "sans-serif"}}>
            <h1>Loading the experiment... Please wait.</h1>
        </div>
    )
}

export default Loading;